import { useState, useEffect, useMemo } from 'react';
import Moment from 'moment';
import toast, { Toaster } from 'react-hot-toast';
import { Row, Col, Card, CardBody, CardHeader, Button, Spinner, Table, Label, Input, Badge, Collapse, FormGroup } from 'reactstrap';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import axios from 'axios';
import { FaPlus, FaChevronRight, FaAutoprefixer, FaChevronLeft, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import uuid from 'react-uuid';
import MapView from '../Map/MapView';
import './Ghg.css';
import Action from '../Action/Action';
import { useNavigate, useLocation } from "react-router-dom";
import Documents from '../Uploads/Documents';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";

const createGroup = (groupName, options, setGmpValue) => {
    return {
        label: (() => {
            return (
                <div
                    onClick={() =>
                        setGmpValue(value =>
                            value.concat(options.filter(grpOpt => !value.includes(grpOpt)))
                        )
                    }
                >
                    {groupName}
                </div>
            );
        })(),
        options: options
    };
};

const Ghg = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const [show_SectionComment, setShow_SectionComment] = useState(false); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const roleName = localStorage.getItem("roleName"); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
        setIsIconUp(!isIconUp);
    };
    const { state } = useLocation();
    const navigate = useNavigate();
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [ghgSection, setGhgSection] = useState({ Section: 'GHG', SectionName: 'Greenhouse Gasses', isWizardCompleted: false, sectionObj: {} });
    const [loading, setLoading] = useState(true);
    const [ghg, setGhg] = useState([]); const [ghgHeader, setGHGHeader] = useState({});
    const [showActionPopup, setShowActionPopup] = useState(false); const [id, setId] = useState(0);
    const [closedActionCount, setClosedActionCount] = useState(0);
    const [openActionCount, setOpenActionCount] = useState(0);
    const [isClosedActionShow, setIsClosedActionShow] = useState(false);
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: true, isFarmCenterEditable: false,
        isFarmOutlineEditable: false, zoomLevel: 15, polytype: '', itemsEditable: false, showDetails: false
    });
    const [itemModel, setItemModel] = useState({ outlineList: [], itemList: [] });
    const [commentonGHGDetails, setCommentonGHGDetails] = useState({ commentonGHG: ''});
    const [savingComments, setSavingComments] = useState(false);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateGreenhouseGasEmissionsProfile, setEditorStateGreenhouseGasEmissionsProfile] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateGreenhouseGasSequestration, setEditorStateGreenhouseGasSequestration] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateGreenhouseGasEmissionsPlanOnFarm, setEditorStateGreenhouseGasEmissionsPlanOnFarm] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateAdverseEventsResponsePlan, setEditorStateAdverseEventsResponsePlan] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const OnPageload = async (e) => {
        try {
            const response = await axios.get(
                '/api/ghg/GetGHG/', {
                    params: { farmId: farmId }
            }
            );
            if (response.data.status) {
                if (response.data.section != null) {
                    var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                    if (section.length > 0) {
                        setIsNextButtonVisible(section[0].isSectionCompleted);
                    }
                }
                setLoading(false);
                setGHGHeader(response.data.content.ghgHeader);
                setGhg(response.data.content);
                setItemModel({ ...itemModel, outlineList: response.data.content.outlineList });
                setMapDetails({ ...mapDetails, zoomLevel: response.data.content.selectedZoomlevel });
                setGhgSection({ ...ghgSection, isWizardCompleted: response.data.content.isFWFPCompleted, sectionObj: response.data.content.section })
                setOpenActionCount(response.data.content.actions.filter(action => action.isCloseout != true).length);
                setClosedActionCount(response.data.content.actions.filter(action => action.isCloseout == true).length);
                setCommentonGHGDetails({ commentonGHG: response.data.content.commentsGHGOverview })
                setShow_SectionComment(response.data.content.show_SectionComment);
                const content = ContentState.createFromBlockArray(convertFromHTML(response.data.content.commentsGHGOverview == null ? '' : response.data.content.commentsGHGOverview))
                setEditorState(EditorState.createWithContent(content));

                const contentGreenhouseGasEmissionsProfile = ContentState.createFromBlockArray(convertFromHTML(response.data.content.ghgHeader.greenhouseGasEmissionsProfile == null ? '' : response.data.content.ghgHeader.greenhouseGasEmissionsProfile))
                setEditorStateGreenhouseGasEmissionsProfile(EditorState.createWithContent(contentGreenhouseGasEmissionsProfile));

                const contentGreenhouseGasSequestration = ContentState.createFromBlockArray(convertFromHTML(response.data.content.ghgHeader.greenhouseGasSequestration == null ? '' : response.data.content.ghgHeader.greenhouseGasSequestration))
                setEditorStateGreenhouseGasSequestration(EditorState.createWithContent(contentGreenhouseGasSequestration));

                const contentGreenhouseGasEmissionsPlanOnFarm = ContentState.createFromBlockArray(convertFromHTML(response.data.content.ghgHeader.greenhouseGasEmissionsPlanOnFarm == null ? '' : response.data.content.ghgHeader.greenhouseGasEmissionsPlanOnFarm))
                setEditorStateGreenhouseGasEmissionsPlanOnFarm(EditorState.createWithContent(contentGreenhouseGasEmissionsPlanOnFarm));

                const contentAdverseEventsResponsePlan = ContentState.createFromBlockArray(convertFromHTML(response.data.content.ghgHeader.adverseEventsResponsePlan == null ? '' : response.data.content.ghgHeader.adverseEventsResponsePlan))
                setEditorStateAdverseEventsResponsePlan(EditorState.createWithContent(contentAdverseEventsResponsePlan));

                if (state != null) {
                    const { itemId, actionId, navigateFrom } = state;
                    navigate(state.pathname, { replace: true });
                    if (navigateFrom == "Actions") {
                        handleNavigateOpenActionPopup(itemId, actionId, response.data.content);
                    }
                }
            }

        } catch (err) {
            console.log(err);
        }
    }

    const handleNavigateOpenActionPopup = (itemId, actionId, ghg) => {
        setShowActionPopup(true);
        setId(actionId)
    };
    const handleCommentsSave = async (e) => {
        e.preventDefault()
        setSavingComments(true);

        let form = {
            Id: farmId,
            commentsGHGOverview: commentonGHGDetails.commentonGHG,
        }
        const response = await axios.post(
            '/api/GHG/GHGOverViewSave/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                toast.success("GHG Overview Comments Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSavingComments(false);
            }
        }
    };

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const mapView = useMemo(() => {
        return (
            <MapView width={'50vw'} height={'50vw'} itemModel={itemModel} mapDetails={mapDetails}></MapView>
        )
    }, [itemModel, mapDetails])

    const CustomToastWithLink = (message) => (
        <div>
            <p>{message}</p>
        </div>
    );
    const customId = "custom-id-yes1";
    const showToastMessage = (e,message) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink(message), {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };
    const [savingSectionComment, setSavingSectionComment] = useState('');

    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent())),
                GreenhouseGasEmissionsProfile: draftToHtml(convertToRaw(editorStateGreenhouseGasEmissionsProfile.getCurrentContent())),
                GreenhouseGasSequestration: draftToHtml(convertToRaw(editorStateGreenhouseGasSequestration.getCurrentContent())),
                GreenhouseGasEmissionsPlanOnFarm: draftToHtml(convertToRaw(editorStateGreenhouseGasEmissionsPlanOnFarm.getCurrentContent())),
                AdverseEventsResponsePlan: draftToHtml(convertToRaw(editorStateAdverseEventsResponsePlan.getCurrentContent())),
                UserId: userId
            };
            const response = await axios.post(
                '/api/ghg/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }
    function loadNonMapItems(Model) {
        return (
            <div>
                
                <Row>
                    <Col>
                        <Card className="my-4">
                            <CardHeader className="d-flex">
                                <h4>Greenhouse Gasses&nbsp;&nbsp;&nbsp;
                                    <img className="featureIcon" src="/images/info_button_dk.png" onClick={(e) => showToastMessage(e,"The GHG page is an optional page that can be activated on the Enterprise and Farm Details page. If you have selected this page as part of your plan you can add some commentary about GHG and your farm.  On the GHG page, you can also raise actions that support improving greenhouse gas emissions, and you can upload supporting documents.")} /></h4>
                            </CardHeader>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col>
                                        <label className="outlineLabel para-light-sm ">Raise GHG related actions based on the below criteria</label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row>
                                            {Model.itemTypes.map(type =>
                                                <Col key={uuid()} sm="6" className="style-item-display">
                                                    <Row>
                                                        <Col sm="1">
                                                            <FaAutoprefixer style={{ fontSize: "15px" }} />
                                                        </Col>
                                                        <Col sm="11">
                                                            <label style={{ marginLeft: "3px" }}> {type.name}</label>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            )}
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Card className="my-4">
                    <CardHeader className="d-flex">
                        
                    </CardHeader>
                    <CardBody>
                            <Row style={{ marginTop: "0.5vh" }}>
                                {show_SectionComment &&  
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "14px" }}><b>Comment or background on GHG overview and reasoning on the farm</b></Label>
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorState}
                                                onEditorStateChange={setEditorState}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>

                                    </Col>    
                                } 
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "14px" }}><b>Greenhouse Gas emissions profile</b></Label>
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateGreenhouseGasEmissionsProfile}
                                                onEditorStateChange={setEditorStateGreenhouseGasEmissionsProfile}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "14px" }}><b>Greenhouse Gas sequestration</b></Label>
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateGreenhouseGasSequestration}
                                                onEditorStateChange={setEditorStateGreenhouseGasSequestration}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "14px" }}><b>Greenhouse Gas emissions plan on farm</b></Label>
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateGreenhouseGasEmissionsPlanOnFarm}
                                                onEditorStateChange={setEditorStateGreenhouseGasEmissionsPlanOnFarm}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "14px" }}><b>Adverse Events Response Plan</b></Label>
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateAdverseEventsResponsePlan}
                                                onEditorStateChange={setEditorStateAdverseEventsResponsePlan}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                    <Col sm="12">
                                        {savingSectionComment ?
                                            <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                                Save
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                    </CardBody>
                </Card>
                
                <Row>
                    <Col>
                        <Card className="my-4">
                            <CardHeader className="card-header-click" onClick={toggle}>
                                <Row>
                                    <Col sm="11">
                                        <h5>Actions&nbsp;&nbsp;&nbsp;
                                            <img className="featureIcon" src="/images/info_button_dk.png" onClick={(e) => showToastMessage(e,"The first form is where you can select, from a drop-down, what risk or risks the action will be mitigating. After you’ve selected the risk, a secondary form will open, and you can complete what land units this action will take place on. In addition, you can choose from a drop-down of possible actions to mitigate this risk. When you’ve chosen an action click on select and you’ll be taken back to the primary form. It will now show your selections and you can complete the additional information and “Save.”")} />
                                        </h5>
                                    </Col>
                                    <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Collapse isOpen={isOpen}>
                                    <Row>
                                        <Col sm="8">
                                        </Col>
                                        <Col sm="4">
                                            {ghg.farmCenter != null &&
                                                <Button className="btn-items-actions" color="success" size="sm" onClick={handleOpenActionPopup} >
                                                    <FaPlus /> Action
                                                </Button>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <table className="table borderless">
                                                <thead></thead>
                                                <tbody>
                                                    {closedActionCount > 0 ?
                                                        <tr key={uuid()}>
                                                            <td>

                                                                <label className="lable-sm-upper float-end">Show Closed Actions ({closedActionCount})</label>
                                                                <input className="float-end closeCheckbox" type="checkbox" checked={isClosedActionShow} onChange={handleClosedActionShow}></input>

                                                            </td>
                                                        </tr>
                                                        : ''}
                                                    {
                                                        ghg.actions != undefined && ghg.actions.length != 0 ?

                                                            <tr className="actions-table" key={uuid()}>
                                                                <td >
                                                                    <Table className='table borderless '>
                                                                        <thead >
                                                                            <tr>
                                                                                <th> # </th>
                                                                                <th style={{ textAlign: 'center' }}> Category </th>
                                                                                <th style={{ width: '10%' }}> Due </th>
                                                                                <th className="text-center"> Opportunity </th>
                                                                           
                                                                                <th style={{ width: '20%' }}> Title  </th>
                                                                                <th style={{ width: '30%' }}> Details </th>
                                                                                <th></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                ghg.actions.map(action =>

                                                                                    <tr key={action.id} className={"" + (action.isCloseout === true ? "closedAction" : "openAction") + " " + (!isClosedActionShow && action.isCloseout === true ? "closed-hidden" : "")}>
                                                                                        <td> {action.id} </td>
                                                                                        <th scope="row" style={{ textAlign: 'center' }}>{action.category == null ? "" : <Badge color="danger">{action.category}</Badge>}  </th>
                                                                                        <td> {action.actionType == 46 ? "Ongoing / Management" : Moment(action.dueDate).format('DD/MM/YYYY')} </td>
                                                                                        <td> {action.ghgItemTypeText} </td>
                                                                                        <td> {action.title} </td>
                                                                                        <td> {action.description} </td>
                                                                                        <td>  {action.isCloseout !== true ?
                                                                                            <Button color="warning" size="sm" onClick={(e) => handleOpenAction(e, action)} > Edit </Button> :
                                                                                            <Button color="primary" size="sm" onClick={(e) => handleOpenAction(e, action)} > View </Button>}
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                            </tr>
                                                            :
                                                            <tr key={uuid()} className="actions-table"><td></td></tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </Col>
                                        </Row>
                                </Collapse>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {/*Document Upload*/}
                {
                    ghgSection.sectionObj.isDocumentUploadReq && <Documents refid={ghgSection.sectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                }
            </div>
        );
    }

    const handleOpenActionPopup = async (e) => {
        setShowActionPopup(true);
        setId(0)
    };

    const handleOpenAction = async (e, item) => {
        setShowActionPopup(true);
        setId(item.id)
    };

    function handleActionClose() {
        setShowActionPopup(false);
    }

    function handleClosedActionShow(event) {
        setIsClosedActionShow(event.target.checked);
    }

    const refreshItemDetails = async () => {
        const response = await axios.get(
            '/api/ghg/GetGHG/', {
            params: { farmId: farmId }
        }
        );
        if (response.data.status) {
            
            setGhg(response.data.content);
            setOpenActionCount(response.data.content.actions.filter(action => action.isCloseout != true).length);
            setClosedActionCount(response.data.content.actions.filter(action => action.isCloseout == true).length);
        }
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{ghgSection.SectionName}</h3></Col>
                {!loading &&
                    <Col>
                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handleWizardChanged(ghgSection.Section)}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        {roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handleMoveToNextPage(ghgSection.Section)}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        <Button className="float-end btn-next-page" onClick={(section) => handleWizardChangedBack(ghgSection.Section)}>Back <FaChevronLeft /> </Button>
                    </Col>
                }
            </Row>
            {loading ? <SpinnerContainer /> :
                <Row>
                    <Col sm="7">
                        {mapView}
                    </Col>
                    <Col sm="5" style={{ marginLeft: "-5vw" }}>
                        {loadNonMapItems(ghg)}
                    </Col>
                </Row>
            }
            {showActionPopup && <Action refreshItemDetails={refreshItemDetails} itemList={[]} isGHGNutrient={true} selectedLUId={0} redirectPage="/ghg" handleActionClose={handleActionClose} itemTypeId={0} sectionName="GHG" sectionId={ghg.itemTypes[0].sectionId} itemId={ghg.farmCenter.itemId} itemName={ghg.farmCenter.name}
                showActionPopupModal={showActionPopup} actionId={id} itemTypeSelect={ghg.itemTypes} itemTypeDisabled={false}></Action>}
        </div>
    )
}
export default Ghg;